import * as React from "react"
import { saTypeButton } from "../saTypes"
// @ts-ignore
import { saBtn } from './saButton.module.scss'

export const SaButton: React.FC<saTypeButton> = (props) =>  {

  if (props.show === true) {
    return(
      <a
        className={saBtn + ' ' + props.classes}
        href={props.link}
        target={props.target ? '_blank' : ''}
        dangerouslySetInnerHTML={{ __html: props.title || "Click" }}
      />
    )
  } else {
    return null
  }

}
